const installationBar = document.getElementById('promote-autowise-to-homescreen');
/**
 * @type {BeforeInstallPromptEvent&Event} deferredInstallPrompt
 */
let deferredInstallPrompt = null;
let supportsPWA = false;
let isDismissed = localStorage.getItem('pwa-install-dismissed') || false;
const isAlreadyRunningInApp = window.matchMedia('(display-mode: standalone)').matches;

if (isAlreadyRunningInApp) {
    localStorage.setItem('pwa-install-dismissed', 'running-in-app');

    document.addEventListener('touchstart', (e) => {
        if (e.pageX > 10 && e.pageX < window.innerWidth - 10) {
            return;
        }

        e.preventDefault();
        document.getElementById('toggleSidebarMobile').click();
    });
}

function hidePromotionBar() {
    isDismissed = true;

    if (installationBar === null) {
        return;
    }

    installationBar.classList.add('translate-y-full');
    setTimeout(() => {
        installationBar.attributes.removeNamedItem('hidden');
    });
}

function showPromotionBar() {
    if (localStorage.getItem('pwa-install-dismissed')) {
        return;
    }

    if (installationBar === null) {
        return;
    }

    installationBar.attributes.removeNamedItem('hidden');

    setTimeout(() => {
        installationBar.classList.remove('translate-y-full');
    }, 1000);
}

window.addEventListener('beforeinstallprompt', (event) => {
    event.preventDefault();
    deferredInstallPrompt = event;
    supportsPWA = true;

    console.debug('Browser supports PWA installation');
});

document.getElementById('install-autowise-pwa')?.addEventListener('click', () => {
    if (!deferredInstallPrompt) {
        return;
    }

    deferredInstallPrompt.prompt();
    deferredInstallPrompt.userChoice.then((response) => {
        deferredInstallPrompt = null;

        if (response.outcome === 'dismissed') {
            return;
        }

        hidePromotionBar();
    });
});

window.addEventListener('appinstalled', hidePromotionBar);

setTimeout(() => {
    if (isDismissed) {
        return;
    }

    if (isAlreadyRunningInApp) {
        return;
    }

    showPromotionBar();

    const containerToShow = supportsPWA
        ? document.getElementById('autowise-native-installation')
        : document.getElementById('autowise-install-via-share');

    if (!containerToShow) {
        return;
    }

    containerToShow.attributes.removeNamedItem('hidden');
}, 1000);

for (const dismissPWAButton of document.getElementsByClassName('dismiss-autowise-pwa')) {
    dismissPWAButton.addEventListener('click', () => {
        hidePromotionBar();
        localStorage.setItem('pwa-install-dismissed', new Date().toISOString());
    });
}
